import { DataBean } from "../DataBean";

export class ExecuteKpis extends DataBean {



    public async executeKpis(date: any, idKpi: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_executeKpis_java.util.Date_Number_Number", [date, idKpi, idEmployee]);
    }

    public async executeKpisRange(fromDate: any, uptoDate: any, idKpi: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_executeKpis_java.util.Date_java.util.Date_Number_Number", [fromDate, uptoDate, idKpi, idEmployee]);
    }

}